/* import __COLOCATED_TEMPLATE__ from './translate-conversation-dropdown.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

interface TranslateConversationDropdownArgs {
  dynamicArgs: {
    hideLimitIndicator: boolean;
    hasTranslationsLeft: boolean;
    quota: { used: number; available: number };
    isDisabled: boolean;
  };
}

interface Signature {
  Args: TranslateConversationDropdownArgs;
}

export default class TranslateConversationDropdown extends Component<Signature> {
  @service declare session: $TSFixMe;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TranslateConversationDropdown': typeof TranslateConversationDropdown;
    'inbox2/translate-conversation-dropdown': typeof TranslateConversationDropdown;
  }
}
